<template>
    <div>
        <kgr-duplication-selection
            v-model="selection"
            label-prefix="employee_contract_status"
            :filter-options="filterOptions"
            :kindergartens="kindergartens"
            class="kgr-row"
            @kindergartenSourceChanged="getEmployeesForKindergartenSource"
            @kindergartenTargetChanged="getEmployeesForKindergartenTarget"
        />

        <kgr-loading v-if="showLoading" />

        <kgr-empty-data
            v-else-if="selection.kindergartenSource === null"
            :value="$t('duplication.employee.empty_data.no_kindergarten')"
        />
        <kgr-empty-data
            v-else-if="sourceEmployees.length === 0"
            :value="$t('duplication.employee.empty_data.filter')"
        />

        <kgr-duplication
            v-else-if="sourceEmployees.length > 0"
            :source-elements="sourceEmployees"
            :target-elements="targetEmployees"
            :kindergarten-source="selection.kindergartenSource"
            :kindergarten-target="selection.kindergartenTarget"
            :filters="selection.filters"
            :in-progress="inProgress"
            :matching-function="(filters, element) => filters.indexOf(element.contractStatus) !== -1"
            type="employee"
            @duplicate="duplicate($event)"
        >
            <template #header>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Status') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Vorname') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Nachname') }}
                </th>
            </template>
            <template #row="scope">
                <td class="kgr-table__cell">
                    <kgr-employee-status-icon
                        :status="scope.element.contractStatus"
                        :title="$t('employee_contract_status.' + scope.element.contractStatus)"
                        small
                    />
                </td>
                <td class="kgr-table__cell">
                    {{ scope.element.firstName }}
                </td>
                <td class="kgr-table__cell">
                    {{ scope.element.lastName }}
                </td>
            </template>
        </kgr-duplication>
    </div>
</template>

<script>
import Duplication from './Duplication';
import DuplicationSelection from './DuplicationSelection.vue';
import Employee from '../../js/dto/Employee';
import EmployeeDuplicationRepository from '../../js/repository/EmployeeDuplicationRepository';
import EmployeeRepository from '../../js/repository/EmployeeRepository';
import EmployeeStatusIcon from '../employees/contract/EmployeeStatusIcon.vue';
import EmptyData from '../common/EmptyData.vue';
import Loading from '../common/Loading.vue';

export default {
    components: {
        'kgr-duplication': Duplication,
        'kgr-duplication-selection': DuplicationSelection,
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
        'kgr-employee-status-icon': EmployeeStatusIcon,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        kindergartens: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selection: {
                filters: [
                    Employee.CONTRACT_STATUS_ACTIVE,
                    Employee.CONTRACT_STATUS_INACTIVE,
                    Employee.CONTRACT_STATUS_SCHEDULED,
                ],
                kindergartenSource: null,
                kindergartenTarget: null,
            },
            filterOptions: [
                Employee.CONTRACT_STATUS_ACTIVE,
                Employee.CONTRACT_STATUS_INACTIVE,
                Employee.CONTRACT_STATUS_SCHEDULED,
            ],
            inProgress: false,
            sourceEmployees: [],
            targetEmployees: [],
            showLoading: false,
        }
    },
    methods: {
        duplicate(elements) {
            this.inProgress = true;
            EmployeeDuplicationRepository.duplicate(elements.map(element => element.id), this.selection.kindergartenTarget.id)
                .then(() => {
                    this.$notify.success('duplication.employee.success');
                    this.getEmployeesForKindergartenTarget(this.selection.kindergartenTarget);
                })
                .catch(() => this.$notify.error('duplication.employee.error'))
                .finally(() => this.progress = false);
        },
        getEmployeesForKindergartenSource(kindergarten) {
            if (this.selection.kindergartenTarget !== null) {
                if (this.selection.kindergartenTarget.id === kindergarten.id) {
                    this.targetChildren = [];
                }
            }
            if (kindergarten === null) {
                this.sourceEmployees = [];
            } else {
                this.showLoading = true;
                EmployeeRepository.findByKindergarten(kindergarten.id)
                    .then( employees => this.sourceEmployees = employees)
                    .catch(() => this.$notify.error('duplication.employees.source.error'))
                    .finally(() => this.showLoading = false);
            }
        },
        getEmployeesForKindergartenTarget(kindergarten) {
            if (kindergarten === null) {
                this.targetEmployees = [];
            } else {
                this.inProgress = true;
                EmployeeRepository.findByKindergarten(kindergarten.id)
                    .then(employees => this.targetEmployees = employees)
                    .catch(() => this.$notify.error('duplication.employees.target.error'))
                    .finally(() => this.inProgress = false);
            }
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
